import { z } from "zod";

/**
 * SalesforceのレコードID。sessionStorage保管値の検証にも同じ契約を流用する。
 */
export const salesforceMapSearchIdSchema = z.string().min(1);

const salesforceRealEstateSchema = z.object({
  salesforceMapSearchId: salesforceMapSearchIdSchema,
  address: z.string().nullable(),
  chiban: z.string().nullable(),
  kaokuNumber: z.string().nullable(),
});

/**
 * `salesforceContext` はキーが常に存在し、値のみ `null` になる契約のため
 * オブジェクト全体に `.nullable()` を適用する（`.optional()` は使わない）。
 */
const salesforceContextSchema = z.object({
  salesforceOrgId: z.string(),
  salesforceUserId: z.string(),
  landingPage: z.string(),
  realEstates: z.array(salesforceRealEstateSchema),
});

/**
 * トークン交換レスポンス（`POST sso/token/`）のうち、ログインの成立に必要な部分。
 * `salesforceContext` の契約が崩れてもログインは継続させるため、検証を二段に分ける。
 */
export const tokenExchangeCoreSchema = z.object({
  access: z.string(),
  refresh: z.string(),
});

/**
 * トークン交換レスポンス（`POST sso/token/`）の契約検証スキーマ。
 * OpenAPIからの型生成が無いため、実行時検証で契約の崩れを検知する。
 */
export const tokenExchangeResponseSchema = tokenExchangeCoreSchema.extend({
  salesforceContext: salesforceContextSchema.nullable(),
});
